<template>

	<div>

		<!-- content: 교과정 목록 -->
		<div id="content" class="content curriculum-list" v-if="mode === '' || mode === 'list' ">
			<div class="container">

				<!-- 페이지 타이틀 -->
				<div class="page-title">
					<h2 class="tit">{{ titleCodeVO.codeName }}</h2>
				</div>

				<!-- 리스트 옵션 -->
				<div class="list-controls">

					<!-- 탭 -->
					<div class="tab swiper-container">
						<ul class="swiper-wrapper">
							<li class="active swiper-slide">
								<a :href="'/app/education/course/' + $route.params.cateCode">교육과정</a>
							</li>
							<li class="swiper-slide">
								<a :href="'/app/education/main/' + $route.params.cateCode">교육과목</a>
							</li>
						</ul>
					</div>

					<form @submit.prevent="doSearch">

						<code-tree-selector v-if="!$options.filters.isEmpty($route.params.cateCode)" :base-code="$route.params.cateCode" :old-code="this.$route.query.cateCode" @selectCode="setCateCode"></code-tree-selector>

						<div class="search">
							<p class="total">총 <span>{{ eduCount }}</span>개의 게시물이 있습니다.</p>
							<div class="search-form">
								<input class="inp-search" id="" name="" type="text" placeholder="검색어를 입력하세요" v-model="params.searchText">
								<button type="submit" class="btn-search"></button>
							</div>
						</div>
					</form>

					<course-sorter @doSort="doSort"></course-sorter>

				</div>

				<course-list :course-list="courseList"></course-list>

				<!-- 버튼 -->
				<div class="btn-area" v-if="courseList.length < eduCount">
					<a href="javascript:;" class="btn-loadmore" @click="doLoadMore">LOAD MORE</a>
				</div>

			</div>
		</div>
		<!--//content -->

		<!-- content: 교과정 상세 -->
		<div id="content" class="content curriculum-view board-list">
			<course-detail v-if="mode === 'detail' && cidx > 0"></course-detail>
		</div>

	</div>

</template>

<script>
import CodeTreeSelector from "@/components/selectors/codeTreeSelector";
import CourseList from "@/components/educations/course/courseList";
import CourseDetail from "@/components/educations/course/courseDetail";
import $ from "jquery";
import Swiper from "../../../public/ssflex/assets/js/swiper.min";
import CourseSorter from "@/components/educations/course/courseSorter";

export default {
	name: "appEduCourses",
	components: {CourseSorter, CourseDetail, CourseList, CodeTreeSelector},
	props: {
		cateCode: String,
		cateName: String,
	},
	data() {

		/**
		 * mode : list, detail
		 * @type {string|string}
		 */
		var mode = this.webUtils.getParameter("mode")
		mode = (mode === '') ? "list" : mode;

		/**
		 * cidx
		 * @type {number|string|string}
		 */
		var cidx = this.webUtils.getParameterInt("cidx");
		cidx = ( cidx > 0 ) ? cidx : 0;

		var params = new this.pageUtils.Params();
		params.size = 8;

		/**
		 * cateCode : params 우선, query 후순위
		 */
		if ( !this.stringUtils.isEmpty( this.$route.params.cateCode ) ) {
			params.cateCode = this.$route.params.cateCode
		} else {
			params.cateCode = this.$route.query.cateCode
		}

		if ( this.stringUtils.isEmpty(params.cateCode) ) {
			params.cateCode = "2001"
		}

		return {
			mode,
			cidx,
			cateCodeVO: {},
			coAccountVO: {},
			titleCodeVO: {},

			params,

			courseList: [],
			eduCount: 0,
			rateCode: 0,
		}
	},
	created() {
		this.$eventBus.$on("goDetail", (_cidx) => {
			this.goDetail( _cidx );
		});

	},
	async mounted() {

		this.titleCodeVO = await this.getCodeOne( this.params.cateCode )

		this.getCourseList();

		$(".list-controls .tab").each(function () {
			var tabnav = new Swiper($(this), {
				slidesPerView: "auto",
				spaceBetween: 24,
				freeMode: true,
				breakpoints: {
					767: {
						spaceBetween: 16,
					},
				},
			});
		});
	},
	methods: {


		getCourseList () {
			this.coAccountVO = this.getSessionProc();

			var temp = this.params
			if ( !this.stringUtils.isEmpty( this.$route.query.cateCode ) ) {
				temp.cateCode = this.$route.query.cateCode;
			}

			this.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get( this, this.APIs.EDU_COURSE + "/", temp, (res) => {
				this.$eventBus.$emit("doneProgress", 1)

				const result = res.data
				if ( result.status === "ok" ) {

					console.log( result )
					// this.eduList.push(...result.list)
					this.courseList = result.list
					this.eduCount = result.count

				} else {
					console.log( result.msg )
				}

			})

		},


		doLoadMore() {

			this.params.page++;
			this.params.scrollTop = false;
			this.pageUtils.routerPush( this, this.params )

			this.getCourseList();
		},


		setCateCode( _cateCode ) {

			// 빈코드가 올 경우 기본 코드 전송
			if ( _cateCode == null || _cateCode === "" ) {
				_cateCode = this.cateCode
			}

			this.params.page = 0
			this.params.cateCode = _cateCode;
			this.params.searchText = "";

			this.pageUtils.routerPush( this, this.params )

			this.getCourseList();
		},


		doSearch(e) {

			e.preventDefault()

			this.params.page = 0
			//this.params.cateCode = "";

			this.pageUtils.routerPush( this, this.params )

			this.getCourseList();
		},



		doSort ( _sort ) {
			this.params.sort = _sort;
			this.pageUtils.routerPush( this, this.params )
			this.getCourseList();
		},



		goDetail(_cidx) {

			this.mode = "detail"
			this.cidx = _cidx
			var temp = {
				mode: this.mode,
				cidx: _cidx,
			}
			this.pageUtils.routerPush(this, temp);
			this.webUtils.scrollTo('.content');
		},

	},
}
</script>

<style scoped>

</style>
